<template>

    <v-card-actions>
        <router-link
            v-if="$can(xprops.permission_prefix + 'edit')"
            :to="{ name: xprops.route + '.edit', params: { id: row.id,
             name:row.name, name_fa:row.name_fa, type:row.type}  }"


        >

            <v-btn fab small color="primary"  class="mx-2">
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </router-link>

<!--        <router-link-->
<!--            to="/permission/permission/create"-->
<!--        >-->
<!--            <v-btn fab small color="primary" @click="goto(`/permission/permission/create`)"  class="mx-2">-->
<!--                <v-icon>mdi-google</v-icon>-->
<!--            </v-btn>-->

<!--        </router-link>-->








        <router-link
            v-if="$can(xprops.permission_prefix + 'show')"
            :to="{ name: xprops.route + '.show', params: { id: row.id } }"
        >

            <v-btn fab small color="#00e676"  class="mx-2">
                <v-icon>mdi-eye</v-icon>
            </v-btn>
        </router-link>


        <v-btn fab small color="error" @click="deleteItem" class="mx-2"  v-if="$can(xprops.permission_prefix + 'delete')">
            <v-icon>mdi-delete</v-icon>
        </v-btn>
    </v-card-actions>




<!--  <div class="dt-action-container">-->
<!--    <router-link-->
<!--      :to="{ name: xprops.route + '.show', params: { id: row.id } }"-->
<!--      class="btn btn-just-icon btn-round btn-link text-azure"-->
<!--    >-->
<!--&lt;!&ndash;        <v-icon >mdi-eye</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;      <i class="material-icons">mdi-refresh</i>&ndash;&gt;-->
<!--        <v-icon>mdi-refresh</v-icon>-->
<!--    </router-link>-->

<!--    <router-link-->
<!--      class="btn btn-just-icon btn-round btn-link text-success"-->
<!--      :to="{ name: xprops.route + '.edit', params: { id: row.id } }"-->
<!--    >-->
<!--&lt;!&ndash;        <v-icon>mdi-pencil</v-icon>&ndash;&gt;-->
<!--      <i class="material-icons">edit</i>-->
<!--    </router-link>-->

<!--    <a-->
<!--      href="#"-->
<!--      class="btn btn-just-icon btn-round btn-link text-rose"-->
<!--      @click.prevent="destroyData(row.id)"-->
<!--      type="button"-->
<!--    >-->
<!--&lt;!&ndash;        <v-icon>mdi-delete</v-icon>&ndash;&gt;-->
<!--      <i class="material-icons">delete</i>-->
<!--    </a>-->
<!--  </div>-->
</template>

<script>
export default {
  props: ['row', 'xprops'],
  data() {
    return {
        data: {
            id: '',
            name: '',
            display_name: '',
            description: '',
            created_at: '',
            updated_at: '',
            deleted_at: '',
        },
      // Code...
    }
  },
  mounted() {
      if (this.xprops == undefined)
          this.xprops = this.$attrs.classes.xprops
    // Code...
  },
  methods: {


      deleteItem() {
          this.$swal({
              title: 'حذف',
              text: 'آیا شما از حذف این مورد مطمئن هستید؟',
              icon: 'warning',
              customClass: {
                  icon: 'icon-custom-class mx-auto',
                  title: 'font-weight-bold',
              },
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'بله',
              cancelButtonText: 'خیر'
          }).then((result) => {
              if (result.isConfirmed) {
                  this.requestApiDelete(`${this.xprops.route}/${this.row.id}`).then(response => {
                      this.xprops.fetchIndexData();
                      this.$emit('delete-success', this.row.id)
                      this.fetchIndexData();
                  })
              }
          })

      },

    destroyData(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#dd4b39',
        focusCancel: true,
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch(this.xprops.module + '/destroyData', id)
            .then(result => {
            })
        }
      })
    }
  }
}
</script>
